import { render, staticRenderFns } from "./ReadAloudImageUploader.vue?vue&type=template&id=97bf8784&scoped=true&"
import script from "./ReadAloudImageUploader.vue?vue&type=script&lang=js&"
export * from "./ReadAloudImageUploader.vue?vue&type=script&lang=js&"
import style0 from "./ReadAloudImageUploader.vue?vue&type=style&index=0&id=97bf8784&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97bf8784",
  null
  
)

export default component.exports